import * as Modules from 'components/modules';
import * as Icons from 'components/modules/Icons';
import { backgroundImageType } from 'types';
import * as MediaQueries from 'components/modules/MediaQueries';
import { easePolyIn } from 'd3-ease';
import T from 'prop-types';
import React from 'react';
import { connect } from 'react-redux';
import * as selectors from 'selectors';
import styles from './sliderMobileSection.css';
import * as s from './styled';

class SliderMobileSection extends React.Component {
  state = {
    index: 0,
    intoView: false,
  };

  componentWillReceiveProps(nextProps) {
    const prevIntoView = this.props.scrollPosition === this.props.scrollIndex;
    const nextIntoView = nextProps.scrollPosition === this.props.scrollIndex;
    if (prevIntoView === nextIntoView) {
      return;
    }

    if (nextIntoView) {
      this.setState({ intoView: true });
    } else {
      this.setState(() => ({ intoView: false }));
    }
  }

  shouldComponentUpdate(nextProps) {
    const { scrollPosition } = nextProps;
    const { scrollIndex } = this.props;
    if (
      scrollPosition !== scrollIndex - 1 &&
      scrollPosition !== scrollIndex &&
      scrollPosition !== scrollIndex + 1
    ) {
      return false;
    }
    return true;
  }

  getIndex = index => Math.abs(index + 2) % this.props.images.length;

  indexCb = index =>
    this.setState(() => ({
      index: this.getIndex(index),
    }));

  intoView = false;

  render() {
    const {
      title,
      subtitle,
      description,
      images,
      reversed,
      colors,
      height,
      textAlign,
      textHorizAlign,
      backgroundImage: {
        mobile: backgroundImageMobile,
        desktop: backgroundImageDesktop,
      },
    } = this.props;
    const { index, intoView } = this.state;
    const reversedNumber = +reversed;
    const isBackgroundImagePresent = !!(
      backgroundImageMobile.src || backgroundImageDesktop.src
    );
    return (
      <s.Section
        backgroundColor={colors.background}
        reversed={reversedNumber}
        height={height}
      >
        {isBackgroundImagePresent && (
          <s.BackgroundOverlay
            backgroundColor={colors.background}
            backgroundImageDesktop={backgroundImageDesktop}
            backgroundImageMobile={backgroundImageMobile}
          />
        )}
        <s.SliderWrapper>
          <MediaQueries.Md>
            <Modules.Dots
              className={styles.dots}
              quantity={images.length}
              color={colors.dots}
              activeIndex={index}
            />
            <Modules.StackCarousel
              active
              cardsQuantity={3}
              scalesArray={[0.9, 1, 0.9]}
              xOffetsArray={[-20, -50, -80]}
              zIndexArray={[1, 2, 1]}
              opacityArray={[0.7, 0, 0.7]}
              className={styles.slider}
              dataArray={images}
              Card={({ src, alt }) => (
                <div className={styles.sliderCard}>
                  <img src={src} alt={alt} className={styles.sliderImg} />
                </div>
              )}
              indexCb={this.indexCb}
              intoView={intoView}
              timing={{ duration: 250, ease: easePolyIn }}
              topFrame={<Icons.phone className={styles.phoneIconDesktop} />}
            />
          </MediaQueries.Md>
          <MediaQueries.ToMd>
            <Icons.phone className={styles.phoneIcon} />
            <Modules.CardStack
              className={styles.cardStack}
              dataArray={images}
              xOffsetsArray={[-50, -50]}
              yOffsetsArray={[-50, -50]}
              leaveTargetArray={[-250, 150]}
              scalesArray={[0.9, 1]}
              cardsQuantity={2}
              Card={({ src, alt }) => (
                <div className={styles.sliderCard}>
                  <img src={src} alt={alt} className={styles.sliderImg} />
                </div>
              )}
            />
          </MediaQueries.ToMd>
        </s.SliderWrapper>

        <s.TextWrapper
          className={styles.textWrapper}
          textAlign={textAlign}
          textHorizAlign={textHorizAlign}
          backgroundColor={!isBackgroundImagePresent && colors.background}
        >
          <s.TextContainer reversed={reversedNumber}>
            <Modules.TextBlock1
              title={title}
              subtitle={subtitle}
              description={description}
              colors={colors}
            />
          </s.TextContainer>
        </s.TextWrapper>
      </s.Section>
    );
  }
}

SliderMobileSection.defaultProps = {
  height: null,
  scrollPosition: null,
  backgroundImage: {
    desktop: {
      src: false,
      backgroundRepeat: false,
      backgroundPosition: false,
      backgroundSize: false,
      backgroundOpacity: false,
    },
    mobile: {
      src: false,
      backgroundRepeat: false,
      backgroundPosition: false,
      backgroundSize: false,
      backgroundOpacity: false,
    },
  },
};
SliderMobileSection.propTypes = {
  title: T.string.isRequired,
  subtitle: T.string.isRequired,
  description: T.arrayOf(T.string).isRequired,
  colors: T.shape({
    background: T.string,
    title: T.string,
    subtitle: T.string,
    description: T.string,
  }).isRequired,
  backgroundImage: T.shape({
    desktop: backgroundImageType,
    mobile: backgroundImageType,
  }),
  reversed: T.oneOfType([T.string, T.number]).isRequired,
  height: T.string,
  images: T.arrayOf(T.shape({ src: T.string, alt: T.string })).isRequired,
  scrollPosition: T.number,
  scrollIndex: T.number.isRequired,
  textAlign: T.string.isRequired,
  textHorizAlign: T.string.isRequired,
};

const mapStateToProps = state => ({
  scrollPosition: selectors.getScrollPosition(state),
});

export default connect(mapStateToProps)(SliderMobileSection);



// WEBPACK FOOTER //
// ./src/components/modules/SliderMobileSection/SliderMobileSection.js